import { ReactElement } from 'react'

import MotoristaRepository from 'modules/motorista/infra/repositories/MotoristaRepository'
import ListMotoristas from 'modules/valePedagio/pages/ListMotoristas'
import FindByCpfNomeFrotistaIdImpl from 'modules/motorista/domain/usecases/FindByCpfNomeFrotistaId'

export const ListMotoristaFactory = (): ReactElement => {
  const repository = new MotoristaRepository()
  const findByCpfNomeFrotistaId = new FindByCpfNomeFrotistaIdImpl(repository)

  return <ListMotoristas findByCpfNomeFrotistaId={findByCpfNomeFrotistaId} />
}
